import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const externalFeesServiceConfigSchema = serviceConfigSchema;
// ============================================================================
// DTO Schema
// ============================================================================
const externalFeesServiceConfigDtoSchema = serviceConfigSchema;

export { externalFeesServiceConfigDtoSchema, externalFeesServiceConfigSchema };
//# sourceMappingURL=ExternalFeesServiceConfig.js.map
